const puntoControlInitialState = {
  puntoControl: {
    idTipo: null,
    mensajeError: null,
    data: null,
    error: false,
    loading: null,
    dto: null,
  },
};

export default puntoControlInitialState;
